import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import { LoadingCom as loadingCom } from '@/utils/loading.js'
import { Message } from 'element-ui'
import store from '@/store/index.js'
Vue.use(VueRouter)
//解决页面重复跳转报错问题
// const originalPush = VueRouter.prototype.push

// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

const routes = [
    {
        path: '/welcome',
        name: 'welcome',
        component: () => import('@/views/Welcome.vue')
    },
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'home',
        component: Home
    },
    {
        path: '/searchCenter',
        name: 'searchCenter',
        component: () => import('@/views/SearchCenter.vue')
    },
    {
        path: '/resume',
        name: 'resume',

        component: () => import('@/views/Resume.vue')
    },
    {
        path: '/interview',
        name: 'interview',

        component: () => import('@/views/Interview.vue')
    },

    {
        path: '/personalCenter',
        name: 'personalCenter',

        component: () => import('@/views/PersonalCenter.vue')
    },
    {
        path: '/careerDetail',
        name: 'careerDetail',

        component: () => import('@/views/CareerDetail.vue')
    },
    {
        path: '/messageCenter',
        name: 'messageCenter',

        component: () => import('@/views/MessageCenter.vue')
    },
    {
        path: '/companyDetail',
        name: 'companyDetail',

        component: () => import('@/views/CompanyDetail.vue'),
        redirect: '/companyDetail/companyBrief',
        children: [
            {
                path: 'companyBrief',
                name: 'companyBrief',
                component: () => import('@/views/CompanyDetailBrief.vue')
            },
            {
                path: 'hotCareer',
                name: 'hotCareer',
                component: () => import('@/views/CompanyHotCareer.vue')
            }
        ]

    },
    {
        path: '/record',
        name: 'record',

        component: () => import('@/views/Record.vue'),
        redirect: '/record/collect',
        children: [
            {
                path: 'browse',
                name: 'browse',
                component: () => import('@/views/RecordList.vue')
            },
            {
                path: 'submit',
                name: 'submit',
                component: () => import('@/views/RecordList.vue')
            }, {
                path: 'collect',
                name: 'collect',
                component: () => import('@/views/RecordList.vue')
            }
        ]

    },
    { path: '*', component: () => import('@/views/NotFound.vue') },

]

const router = new VueRouter({
    mode: 'history',
    routes
})
// 配置路由守卫

router.beforeEach((to, from, next) => {




    if (['/resume', '/interview', '/personalCenter', '/messageCenter', '/record/browse', '/record/collect', '/record/submit', '/welcome']
        .indexOf(to.path) !== -1) {

        const token = localStorage.getItem('user-token')
        if (token) {


            if (from.path == '/welcome' && localStorage.getItem("user-fillState") !== '1') { //如果当前是欢迎页面且填充状态为未填充，则禁止跳转

                next(false)
                return

            } else {
                console.log(2)
                next()// 放行 
            }

        } else {
            store.state.redirectUrl = to.path //记录一下路径，用作登录成功后进行调整
            Message.error('请先登录')

            store.state.isShowLoginBox = true

        }
    } else {

        next()
    }

})

export default router
